export default __webpack_public_path__ + "static/superseis-bbad127b01c42c0cac444cfa2075ea97.png";